import { memo, useCallback, useEffect } from 'react';
import ListItem from '@mui/material/ListItem';
import { useParams, useNavigate } from 'react-router-dom';
// Local files
import { ItemTitle, StyledListItemButton } from './Item.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useLocations from 'hooks/useLocations';
import useCustomSelector from 'hooks/useCustomSelector';
import { locationsSelectors } from 'features/locations';

const Item = ({ id, name }) => {
  const { location_id } = useParams();
  const navigate = useNavigate();
  const { getLocation } = useLocations();
  const fetching = useCustomSelector(locationsSelectors.locationIsFetching)

  const handleSelectLocation = (e) => { 
    e.stopPropagation();
    id !== location_id && navigate(`/locations/${id}`) 
  };
  const fetchLocation = useCallback((location_id) => {
    getLocation(location_id)
  }, [getLocation]);

  useEffect(() => {
    !!location_id && id === location_id && fetchLocation(location_id); 
  }, [id, location_id, fetchLocation]);

  return (
    <ListItem disablePadding>
      <StyledListItemButton selected={id === location_id} disabled={fetching} onClick={handleSelectLocation}>
        <ItemTitle>{name}</ItemTitle>
      </StyledListItemButton>
    </ListItem>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Item {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);